import { useEffect } from 'react';
import { useSystemOptionsStore } from '../stores/useOptions';
import { Alert } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import { ApiUrl, Headers } from '../services/ApiUrl';
import { useLocation } from 'react-router-dom';

const SystemOptionsLoader = () => {
    const { updateSystemOptions } = useSystemOptionsStore();
    const [error, setError] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const fetchOpciones = async () => {
            try {
                let url = ApiUrl + 'getopciones';
                const response = await axios.get(url, { headers: Headers });

                if (!response.data || !response.data.opciones) {
                    throw new Error('Formato de respuesta inválido');
                }

                const opciones = response.data.opciones;
                
                const opcionesParaStore = {
                    votacionActiva: opciones.voto_activo?.valor 
                        ? parseInt(opciones.voto_activo.valor) 
                        : 0,
                    whatsapp: opciones.whatsapp?.valor || '',
                    mailAyuda: opciones.mail_ayuda?.valor || '', // Nueva opción
                };

                if (typeof opcionesParaStore.votacionActiva !== 'number') {
                    opcionesParaStore.votacionActiva = 0;
                }

                updateSystemOptions(opcionesParaStore);
                setError(null);

            } catch (error) {
                console.error('Error al cargar opciones del sistema:', error);
                setError('Error al cargar las opciones del sistema. Por favor, recarga la página.');
            }
        };

        fetchOpciones();
    }, [location.pathname, updateSystemOptions]);

    return error ? (
        <Alert variant="danger" className="m-3">
            {error}
        </Alert>
    ) : null;
};

export default SystemOptionsLoader;